<template>
  <div class="rounded-[2.4rem] border border-black/10 bg-white px-4 py-3 xl:hidden">
    <button
      type="button"
      class="flex w-full items-center justify-between gap-3 text-left"
      @click="$emit('update:open', !open)"
    >
      <span class="text-[1.4rem] font-semibold text-black">{{ $t('Reservations summary') }}</span>
      <div class="flex items-center gap-2 text-black">
        <span class="text-[1.3rem] font-semibold">{{ formatValue(totalDue) }}</span>
        <svg
          class="h-4 w-4 transition-transform duration-200"
          :class="open ? 'rotate-180' : ''"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
    </button>
    <div
      v-if="open"
      class="mt-4 space-y-3"
    >
      <div
        v-for="sale in saleCards"
        :key="sale.id"
        class="space-y-3 rounded-[1.6rem] border border-black/10 bg-black/[0.02] p-4"
      >
        <div class="flex flex-col gap-3">
          <div class="flex items-start gap-3">
            <DoctorImage :image="sale.avatar || ''" :name="sale.doctorName || ''" />
            <div class="flex-1 min-w-0 space-y-2">
            <p
              v-if="sale.typeLabel || sale.modeLabel"
              class="m-0 text-[1rem] font-semibold uppercase tracking-wide text-black/50"
            >
              <span v-if="sale.typeLabel">{{ sale.typeLabel }}</span>
              <span v-if="sale.typeLabel && sale.modeLabel"> - </span>
              <span v-if="sale.modeLabel">{{ sale.modeLabel }}</span>
            </p>
            <p class="m-0 text-[1.4rem] font-semibold leading-snug text-black whitespace-pre-line">
              {{ sale.service }}
            </p>
            <p v-if="sale.doctorName || sale.tenant" class="m-0 text-[1.2rem] text-[color:var(--gray)] whitespace-pre-line">
              <span v-if="sale.doctorName">{{ sale.doctorName }}</span>
              <span v-if="sale.doctorName && sale.tenant"> • </span>
              <span v-if="sale.tenant">{{ sale.tenant }}</span>
            </p>
            <div class="space-y-1 text-[1.2rem] text-black">
              <p v-if="sale.date" class="m-0 whitespace-pre-line">
                {{ sale.date }}
              </p>
              <p v-if="sale.duration" class="m-0 whitespace-pre-line">
                {{ sale.duration }}
              </p>
            </div>
            </div>
          </div>
          <div class="text-right self-end">
            <p class="m-0 text-[1.3rem] font-semibold text-black">{{ sale.pendingLabel }}</p>
            <p v-if="sale.depositLabel" class="m-0 text-[1.1rem] font-normal text-[color:var(--gray)]">
              {{ $t('Deposit today: {amount}', { amount: sale.depositLabel }) }}
            </p>
          </div>
        </div>
        <button
          type="button"
          class="text-[1.1rem] text-red-600 underline"
          @click="$emit('remove-sale', sale.saleId)"
        >
          {{ $t('Remove') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DoctorImage from '@/components/doctor/doctorImage.vue';

export default {
  name: 'CheckoutSummaryMobile',
  components: {
    DoctorImage,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    saleCards: {
      type: Array,
      default: () => [],
    },
    totalDue: {
      type: Number,
      default: 0,
    },
    formatAmount: {
      type: Function,
      default: null,
    },
  },
  emits: ['update:open', 'remove-sale'],
  methods: {
    formatValue(value) {
      if (typeof this.formatAmount === 'function') {
        return this.formatAmount(value);
      }
      return value === undefined || value === null ? '-' : String(value);
    },
  },
};
</script>
